(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stacked-text-rectangles"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.getElementById('rectangles-wrapper');
  const hoverTitle = wrapper.getAttribute('data-hover-title');
  const rectangles = wrapper.querySelectorAll('.rectangle');
  const rect1 = rectangles[0];
  const titleLink = rect1.querySelector('h2 a');
  const originalTitle = titleLink.textContent;

  // Equalize heights of the two rectangles
  if (rectangles.length === 2) {
    const [rect1, rect2] = rectangles;
    const maxHeight = Math.max(rect1.offsetHeight, rect2.offsetHeight);
    rect1.style.height = maxHeight + 'px';
    rect2.style.height = maxHeight + 'px';
  }

  // Hover / touch handlers for changing title text and toggling border color
  function setHoverState(isHover) {
    if (isHover) {
      titleLink.textContent = hoverTitle;
      wrapper.classList.add('touched');
    } else {
      titleLink.textContent = originalTitle;
      wrapper.classList.remove('touched');
    }
  }

  // Desktop: hover on title link triggers title change
  titleLink.addEventListener('mouseenter', () => setHoverState(true));
  titleLink.addEventListener('mouseleave', () => setHoverState(false));

  // Touch devices: touchstart and touchend on entire rectangles wrapper toggle title and border color
  rectangles.forEach(rect => {
    rect.addEventListener('touchstart', () => setHoverState(true));
    rect.addEventListener('touchend', () => {
      setTimeout(() => setHoverState(false), 500);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
